import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Device } from '@capacitor/device';
import { LanguageService } from '../services/language/language.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class DeviceInterceptor implements HttpInterceptor {
  deviceID: any;
  fcmToken : string | null = ""

  constructor(private language: LanguageService) {
    if (localStorage.getItem('deviceID')) {
      this.deviceID = localStorage.getItem('deviceID');
    } else {
      this.getDeviceID().then((e: any) => {});
    }

    this.fcmToken  = localStorage.getItem('fcmToken');
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: {
              lang: this.language.userLanguage
            },
      setParams: {
        mac_id: String(this.deviceID),
        fcmToken: String(this.fcmToken ?? ""),
        api_key: environment.api_key
      },
    });
    return next.handle(request);
  }

  async getDeviceID() {
    this.deviceID = localStorage.getItem('deviceID');
    if( localStorage.getItem('deviceID') == undefined){
      this.deviceID = (await Device.getId()).identifier;
      localStorage.setItem('deviceID', this.deviceID);
    }
 

    return this.deviceID;
  }
}
